var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9036b3363d77c60464d10fef6f714c40fd46d1b1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend@distribute-e0"]={id:"9036b3363d77c60464d10fef6f714c40fd46d1b1"};
      